module.exports = __webpack_public_path__ + "media/images/prop-img-1152-ccf362ab57e2bdf5daa9c2d45fac6602.svg";